import React, { useEffect, useState } from "react";
import { UsersInnerOptions } from "../UsersInnerOptions";
import { useQuery } from "react-query";
import { getWarehouseMembers } from "hooks/api/Users/getWarehouseMembers";
import { useErrorHandler } from "Exceptions/ErrorHandler";
import { SettingLayout } from "layouts/SettingLayout";
import { useColumns } from "./columns";
import { DataTable } from "components/ui/DataTable";
import { WarehouseMember } from "contracts/WarehouseMembers";

const ListWarehouseMember = () => {
  const { options } = UsersInnerOptions();
  const [localData, setLocalData] = useState<WarehouseMember[]>([]);
  const { errorHandler } = useErrorHandler();
  const { columns } = useColumns();
  const { data, isLoading } = useQuery({
    queryKey: "warehouseMembers",
    queryFn: getWarehouseMembers,
    onError: errorHandler,
  });

  useEffect(() => {
    if(data) {
        setLocalData(data);
    }
    return () => {
        setLocalData([]);
    };
}, [data]);
  return (
    <SettingLayout options={options}>
      <DataTable
        isLoading={isLoading}
        data={localData ?? []}
        filterBy={'Nome'}
        columns={columns}
        showControlColumns={false}
      />
    </SettingLayout>
  );
};

export default ListWarehouseMember;
